/* Built In Imports */

/* External Imports */
import { Box, Heading, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';

/**
 * @param {Object} sectionContent - Data from api
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 * @returns
 */

const WhatIsPS = ({ sectionContent }) => {
  const imageUrl = sectionContent.find(item => item.fieldId === 'left-image')
    ?.image?.url;
  const experienceText = sectionContent.find(
    item => item.fieldId === 'text-1'
  )?.text;
  const classicalArtsText = sectionContent.find(
    item => item.fieldId === 'text-2'
  )?.text;
  const transformationText = sectionContent.find(
    item => item.fieldId === 'text-3'
  )?.text;
  const structuredText = sectionContent.find(
    item => item._modelApiKey === 'structured_text'
  )?.body?.value?.document?.children[0]?.children[0]?.value;

  return (
    <Box
      position="relative"
      // mt={{ base: 'rem' }}
      // border={'2px solid red'}
      backgroundImage={{
        base: `${config.imgPath}/d/46272/1724861378-mask-group.png`,
        md: `${config.imgPath}/d/46272/1722360335-group-1316.png`,
      }}
      backgroundSize={'100% 100%'}
      backgroundPosition={'center'}
      backgroundRepeat="no-repeat"
      justifyContent="center"
      pt={{ lg: '0', base: '0' }}
      pb={{ md: '12rem', xl: '16rem', base: '8rem', '2xl': '21rem' }}
      //pr={{ base: '0', md: '0', lg: '4rem', xl: '7rem' }}
    >
      {/* white top line box */}
      <Box
        bg={'#FFFFFF'}
        display={{ md: 'none' }}
        // border={'3px solid white'}
        position={'relative'}
        // top={'-13rem'}
      />
      <Heading
        my={{ md: '4rem', xl: '8rem', base: '.5rem' }}
        position={'relative'}
        color="#FEFAF6"
        lineHeight={{ lg: '72px' }}
        fontSize={{ base: '44px', md: '50px', '2xl': '60px' }}
        textAlign="center"
        fontFamily="var(--FedraSerifDisplay-Bold)"
      >
        {sectionContent[0]?.text}
      </Heading>
      <Box
        maxW={{ base: 1170, '2xl': 1400 }}
        // flexDirection={{ base: 'column-reverse', lg: 'row-reverse' }}
        width="100%"
        mx="auto"
        flexDirection={{ base: 'column-reverse', lg: 'row-reverse' }}
        display="flex"
        // border="2px solid pink"
        justifyContent={{ lg: 'center' }}
        paddingX={{ base: '1rem', lg: '0' }}
        alignItems={{ lg: 'center' }}
        mt={{ base: '10rem', md: '15rem', lg: '0' }}
        position="relative"
        // paddingLeft={{ base: "0", lg: "15%" }}
        pl={{ lg: '0' }}
        pr={{ lg: '0' }}
      >
        <Box
          display={{ base: 'flex' }}
          alignItems={{ lg: 'center' }}
          mt={{ base: '-12rem', md: '-15rem', lg: '0' }}
          flexDirection={{ base: 'column-reverse', lg: 'row-reverse' }}
          w={{ base: '100%', lg: '80%' }}
          paddingRight={{ md: '2rem', lg: '0' }}
          paddingLeft={{ md: '2rem', lg: '5rem', xl: '10rem', '2xl': '12rem' }}
          minHeight={{ lg: '500px' }}
          paddingTop={{ base: '200px', md: '54px', lg: '2rem', xl: '8rem' }}
          paddingY={{ '2xl': '10rem' }}
          pb={{ base: '7%', md: '5%', lg: '8rem' }}
          bg={{
            base: 'linear-gradient(1deg, #FEFAF6 -0.37%, #FEFAF6 -0.36%, rgba(254, 250, 246, 0.791556) 59.71%, rgba(254, 250, 246, 0.665) 74.22%, rgba(254, 250, 246, 0) 99.75%)',

            lg: 'linear-gradient(270deg, #fefaf6, #fefaf6 0.01%, rgba(254, 250, 246, 0.79) 60%, rgba(254, 250, 246, 0.67) 74.5%, rgba(254, 250, 246, 0))',
          }}
          ml="auto"
        >
          <Box
            mr={{ md: '2rem', xl: '4rem' }}
            mt={{ base: '14rem', md: '14rem', lg: '0' }}
            ml={{ md: '0', lg: '5rem', xl: '3rem' }}
            width={'100%'}
          >
            <Box
              mx={{ base: '2rem', md: '0' }}
              // mt={{ lg: '3rem' }}
              //  ml={{ lg: '20' }}
              color={'#010509'}
            >
              <Text
                fontSize={{ base: '1.5rem', lg: '40px', '2xl': '2.75rem' }}
                fontFamily={'var(--FedraSerifDisplay-Regular)'}
                lineHeight={{ base: '28.8px', xl: '3rem', '2xl': '52.8px' }}
                letterSpacing="1%"
              >
                {experienceText}
              </Text>
              <Text
                fontFamily={'var(--FedraSerifDisplay-Bold)'}
                lineHeight={{ lg: '3.75rem', base: '28.8px', '2xl': '72px' }}
                letterSpacing="1%"
                fontSize={{
                  base: '1.5rem',
                  md: '2.3rem',
                  lg: '50px',
                  '2xl': '3.75rem',
                }}
              >
                {classicalArtsText}
              </Text>
              <Text fontSize={{ base: '1.3rem', md: '2rem' }}>
                {transformationText}
              </Text>
            </Box>

            <Box
              fontSize={{ base: '0.875rem', md: '1.125rem' }}
              // width={{ md: "67%" }}
              // ml={{ lg: '20' }}
              mx={{ base: '2rem', md: '0' }}
              fontFamily="var(--FedraSansStd-book)"
              mt={{ base: '1rem', lg: '3rem' }}
              letterSpacing="2%"
              fontWeight="350"
              color={'#0E1216'}
              lineHeight={{ base: '22.4px', md: '1.7rem' }}
              //  border={"2px"}
            >
              <Text
                // noOfLines={{ md: "3" }}
                mb={{ base: '1.5rem' }}
              >
                {structuredText.split('\n\n')[0]}
              </Text>
              <Text
              //  noOfLines={{ md: "3" }}
              >
                {structuredText.split('\n\n')[1]}
              </Text>
            </Box>
          </Box>
        </Box>

        <Box
          position={{ base: 'relative', lg: 'absolute' }}
          objectFit="cover"
          // py={{ lg: '5rem' }}
          left={{ lg: '0', xl: '5%', '2xl': '4%' }}
          bottom={0}
          // height={'800px'}
          height={{ xl: '582.71px', '2xl': '729.04px' }}
          w={{
            base: '70%',
            md: '40%',
            lg: '36%',
            xl: '333.98px',
            '2xl': '417.04px',
          }}
          m="0 auto"
          mt={{ base: '-30%', md: '-25%', lg: '0' }}
          top={{ lg: '0', base: '0', xl: '8%', '2xl': '5%' }}
        >
          {imageUrl && (
            <LazyLoadImageComponent
              src={imageUrl}
              alt="Dance performance"
              objectPosition="center"
              verticalAlign="middle"
              objectFit="fill"
              height={{ md: 'auto', lg: '100%' }}
              width={'100%'}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default WhatIsPS;
